import React from "react";
import Social from "../Social";

const socialList = [
  {
    name: "FB.",
    link: "https://www.facebook.com/ahmmedabir.09",
  },
  {
    name: "GH.",
    link: "https://github.com/ahmmedabir9",
  },
  {
    name: "IN.",
    link: "https://www.linkedin.com/in/abu-musa-ahmed-abir-524897138/",
  },
  {
    name: "SW.",
    link: "https://stackoverflow.com/users/11701032/ahmmed-abir",
  },
];

const SliderDark = () => {
  return (
    //    HERO
    <div className="beny_tm_hero" id="home">
      <div className="background">
        <div
          className="image"
          // style={{
          //   backgroundImage: `url(${
          //     process.env.PUBLIC_URL + "img/slider/1.jpg"
          //   })`,
          // }}
        ></div>
        <div className="overlay"></div>
      </div>
      {/* End bg */}

      <div className="go-to go-to-next">
        <a href="#about">
          <span></span>
        </a>
      </div>
      {/* End animated goto button */}

      <div className="container">
        <div className="content">
          <div className="content_inner">
            <h3 className="name">Hi! I'm</h3>
            <h1 className="job">
              Ahmmed Abir
              <br />{" "}
            </h1>
            <p className="text">A Human Being who talks with machine.</p>
            <div className="mobile_social">
              <Social />
            </div>
            {/* End .social */}

            <div className="beny_tm_button">
              <a className="anchor" href="#portfolio">
                <span className="wrapper">
                  <span className="first">Portfolio</span>
                  <span className="second">Portfolio</span>
                </span>
              </a>
            </div>
            {/* End beny_tm_button */}
          </div>
        </div>
      </div>
      {/* End .container */}

      <div className="social">
        <ul>
          {socialList.map((val, i) => (
            <li key={i}>
              <a href={val.link} target="_blank">
                <span className="first">{val.name}</span>
                <span className="second">{val.name}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
      {/* End .social */}
    </div>
    //HERO
  );
};

export default SliderDark;
